<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
    class="card"
  >
    <div v-if="data" slot="header" class="clearfix">
      <div class="header">
        <div class="header__title">
          <span slot="reference">
            По сумме BTC
          </span>
        </div>
        <div
          class="header__button"
          @mouseover="progressHovered = true"
          @mouseleave="progressHovered = false"
        >
          <div v-show="progressHovered">
            <el-button
              :disabled="!forceEnabled"
              type="primary"
              icon="el-icon-refresh"
              circle
              size="mini"
              @click="forceData"
            ></el-button>
            <!-- <el-button v-else type="primary" circle size="mini">{{
              forceCooldownSeconds
            }}</el-button> -->
          </div>
          <el-progress
            v-show="!progressHovered"
            :percentage="persComputed"
            type="circle"
            :width="28"
            :stroke-width="2"
            :format="pers => ``"
          ></el-progress>
        </div>
      </div>
    </div>
    <div v-if="data.totalBtc && data.avgExchangeRate">
      <div class="content justify-start" v-if="data">
        <div>Всего: {{ data.totalBtc.toFixed(8) }} BTC</div>
      </div>
      <div class="content justify-start" v-if="data">
        <div>
          AVG:
          {{ data.avgExchangeRate.toFixed(2) }}
          RUB/BTC
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        Для получения данных - нажми на колечко
      </div>
    </div>
    <div class="content justify-end">
      <div class="small" :class="{ 'error-text': loadError }">
        {{ updatedAgoReadable }}
        <span v-if="loadError">· ошибка обновления</span>
      </div>
    </div>
    <div class="content" v-if="!data && !loading">
      <div>
        Ошибка получения данных!
      </div>
    </div>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "DashboardBiTotalElement",
  data: () => ({
    autoRefresh: false,
    refreshRate: 60 * 60 * 1000,
    interval: null,
    remainedInterval: null,
    remainedTime: 0,
    updatedAgo: 0,
    forceCooldownSeconds: 10,
    forceInterval: null,
    progressHovered: false,
    loadedAt: null,
    loadError: false
  }),
  computed: {
    ...mapState("ledgerBi", {
      data: state => state.ledgerBiTotal,
      loading: state => state.loadingTotal
    }),
    updatedAgoReadable() {
      if (!this.updatedAgo) return "N/A";
      return `${this.timeAgo(this.updatedAgo)}`;
    },
    forceEnabled() {
      return !this.forceCooldownSeconds;
    },
    persComputed() {
      if (!this.refreshRate) return 0;
      if (!this.autoRefresh) return 0;
      return (this.remainedTime * 100) / this.refreshRate;
    }
  },
  methods: {
    ...mapActions("ledgerBi", ["getLedgerBiTotal"]),
    getAgo() {
      if (!this.loadedAt) return "N/A";
      const msAgo = this.$dayjs(new Date()).diff(this.$dayjs(this.loadedAt));
      return this.timeAgo(msAgo);
    },
    async getData() {
      if (this.interval) clearTimeout(this.interval);
      this.remainedTime = this.refreshRate;
      try {
        await this.getLedgerBiTotal();
        this.loadError = false;
        this.loadedAt = new Date();
        this.updatedAgo = 0;
      } catch (error) {
        this.loadError = true;
      } finally {
        if (this.autoRefresh)
          this.interval = setTimeout(this.getData, this.refreshRate);
      }
    },
    async forceData() {
      this.forceCooldownSeconds = 10;
      await this.getData();
    }
  },
  async mounted() {
    // await this.getData();
    // this.interval = setTimeout(this.getData, this.refreshRate);
    this.remainedInterval = setInterval(() => {
      this.remainedTime -= 1000;
      this.updatedAgo += 1000;
    }, 1000);
    this.forceInterval = setInterval(() => {
      this.forceCooldownSeconds =
        this.forceCooldownSeconds <= 0 ? 0 : this.forceCooldownSeconds - 1;
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    // clearInterval(this.interval);
    clearInterval(this.remainedInterval);
    clearInterval(this.forceInterval);
  }
};
</script>
<style scoped>
.card {
  min-width: 200px;
  width: 280px;
}
.content {
  display: flex;
  align-items: baseline;
}

.content .justify-center {
  justify-content: center;
}
.content .justify-end {
  justify-content: end;
}
.content .justify-start {
  justify-content: start;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.header__title {
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header__button {
  height: 28px;
}
.small {
  /* margin-top: 1rem; */
  font-size: 0.65rem;
  margin-left: 0.2rem;
  color: rgba(0, 0, 0, 0.5);
}
.error-text {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/Dashboard/ledgerBiTotal.vue